"use client";

import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardHeader, CardTitle } from "@/src/components/shadcn/ui/card";
import { ReferralMatchEvidence } from "@/src/components/tasks/approval-types/referral-match-evidence";
import { ApprovalType, type TaskApproval } from "@/src/models/task-approval";
function EvidenceContent(t0) {
  const $ = _c(2);
  const {
    approval
  } = t0;
  switch (approval.approvalType) {
    case ApprovalType.REFERRAL_MATCH:
      {
        let t1;
        if ($[0] !== approval.metadata) {
          t1 = <ReferralMatchEvidence metadata={approval.metadata} />;
          $[0] = approval.metadata;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
  }
}
export function ApprovalEvidenceCard(t0) {
  const $ = _c(3);
  const {
    approval
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CardHeader><CardTitle className="text-center">Action Pending Review</CardTitle></CardHeader>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== approval) {
    t2 = <Card className="bg-warn/5 border border-warn/20">{t1}<CardContent><EvidenceContent approval={approval} /></CardContent></Card>;
    $[1] = approval;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}